import React from 'react';

const NeedHelp = () => {
  return (
    <div className="vads-u-margin-top--6 usa-width-two-thirds vads-u-padding-x--1">
      <va-need-help>
        <div slot="content">
          <p>
            <strong>If you need help completing the form, </strong>email us at{' '}
            <va-link
              text="yellow.ribbon@va.gov"
              href="mailto:yellow.ribbon@va.gov"
            />
            .
          </p>
        </div>
      </va-need-help>
    </div>
  );
};

export default NeedHelp;
